import React, { PureComponent } from 'react'
import CSSModules from 'react-css-modules'

import CookiesNotSupportedContainer from 'containers/cookies_not_supported/container'
import styles from './route.scss'

class CookiesNotSupportedRoute extends PureComponent {

	render() {
		return (
			<div styleName='wrapper'>
				<CookiesNotSupportedContainer/>
			</div>
		)
	}
}

export default CSSModules(CookiesNotSupportedRoute, styles, {allowMultiple: true})
